import InterfaceList from "../apiInterface/InterfaceList";
import ErrorAlert from "@/utility/ErrorAlert";

class DataList {
  // async getPasienByStatus(st, tgl) {
  // getPasienByStatus(st, tgl) {
  //   let dt: Array<object> = []
  //   // await InterfaceListPasien.getAllbyStatus(st, tgl).then((response) => {
  //   InterfaceListPasien.getAllbyStatus(st, tgl).then((response) => {
  //     dt = response.data.data
  //   })
  //   .catch((e) => {
  //     console.log(e);
  //   });
  //   return dt
  // }

  async getListPasien(kdPoli, tgl, status, kdDokter) {
    // let dt: Array<object> = []
    let dt: any
    await InterfaceList.getPasien(kdPoli, tgl, status, kdDokter).then((response) => {
      // InterfaceListPasien.getAllbyStatus(kdPoli).then((response) => {
      dt = response.data
      // console.log(dt)
    })
      .catch((e) => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Pasien")
        // dt = {
        //   status: 0,
        //   err: e.response
        // }
        // if (dt['status'] == 422) {
        //   dt = { status: 0, err: "Gagal Ambil Data List Pasien ERROR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "Gagal Ambil Data List Pasien ERROR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt
  }


  async getListPasienKonsulan(kdPoli, sort, tglStart, tglEnd) {
    let dt: any
    await InterfaceList.getPasienKonsulan(kdPoli, sort, tglStart, tglEnd).then((response) => {
      dt = response.data
      // console.log(dt)
    })
      .catch((e) => {
        dt = e.response
        // console.log(e);
        // dt = {
        //   status: 0,
        //   err: e.response
        // }
        // if (dt['status'] == 422) {
        //   dt = { status: 0, err: "Gagal Ambil Data List Pasien Konsulan ERROR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "Gagal Ambil Data List Pasien Konsulan ERROR " + e.response.status + " : " + e.response.data.message }
        // }
        ErrorAlert.showSnackAlert(e, "List Pasien Konsul")
      });

    // console.log(dt)
    return dt
  }
  async getListPasienRanap(kdPoli) {
    // let dt: Array<object> = []
    let dt: any
    await InterfaceList.getPasienRanap(kdPoli).then((response) => {
      // InterfaceListPasien.getAllbyStatus(kdPoli).then((response) => {
      dt = response.data
      // console.log(dt)
    })
      .catch((e) => {
        // console.log(e);
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Pasien")
        // dt = {
        //   status: 0,
        //   err: e.response
        // }
        // if (dt['status'] == 422) {
        //   dt = { status: 0, err: "Gagal Ambil Data List Pasien ERROR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "Gagal Ambil Data List Pasien ERROR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt
  }

  async getListPasienUnit(kdPoli) {
    let dt: any
    await InterfaceList.getPasienUnit(kdPoli).then((response) => {

      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "List Pasien")
      });

    return dt
  }


}

export default new DataList();
